export {};
//# sourceMappingURL=is-native-context-function.js.map